export const ISSUES_FOR_PRESSING_REQUEST = "ISSUES_FOR_PRESSING_REQUEST";
export const ISSUES_FOR_PRESSING_SUCCESS = "ISSUES_FOR_PRESSING_SUCCESS";
export const ISSUES_FOR_PRESSING_FAILED = "ISSUES_FOR_PRESSING_FAILED";